<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import { nlToBr } from '@utils/index'
import Layout from '@layout/En/main'
import SectionBanner from '@views/Home/components/SectionBanner'
import { optionComputed } from '@store/helpers'
import ItemMultiple from '../Brand/Event/ItemMultiple.vue'
import store from '@store'

export default {
    page: {
        // All subcomponent titles will be injected into this template.
        titleTemplate(title) {
        const setting = store.state.global.currentSetting || ''
        title = typeof title === 'function' ? title(this.$store) : title
        return title ? `${title} | ${setting.sitename || appConfig.title}` : setting.sitename || appConfig.title
        },
    },
    components: {
        Layout,
        SectionBanner,
        Slick
    },
    props: {
        module: {
            type: Object,
                default: () => {
                return {}
            },
        },
        currentBrandList: {
            type: Array,
            default: () => {
                return []
            },
        },
        aboutCompany: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        const DEFAULT_PAGE_COUNT = 1;
        return {
            isAutoPlay: true,
            pageCount: DEFAULT_PAGE_COUNT,
            brandList: [],
            contactList: [
                {
                    title: "Taipei office",
                    address: "10th Floor, No. 8, Lane 360,Section 1, Neihu Road, Neihu District, Taipei City",
                    tel: "886-2-2656-5656",
                    fax: "886-2-2656-0810",
                    show: false
                },
                // {
                //     title: "Warehouse．Repair Center",
                //     address: "5th Floor, No. 5, Lane 22, Lane 512, Ruiguang Road, Neihu District, Taipei City",
                //     tel: "886-2-2656-5650",
                //     fax: "886-2-2657-6455",
                //     show: false
                // },
                {
                    title: "Hsinchu Office",
                    address: "17F-3, No. 118, Ciyun Road, East District, Hsinchu City",
                    tel: "886-3-668-6638",
                    fax: "886-3-668-6856",
                    show: false
                },
                {
                    title: "Taichung Office",
                    address: "Room A1, 15th Floor, No. 497, Zhongming South Road, West District, Taichung City",
                    tel: "886-4-2373-0908",
                    fax: "886-4-2373-0398",
                    show: false
                },
                {
                    title: "Kaohsiung Office",
                    address: "Room 502, 5th Floor, No. 200, Zhisheng Road, Zuoying District, Kaohsiung City",
                    tel: "886-7-535-3773",
                    fax: "886-7-535-3776",
                    show: false
                },
                // {
                //     title: "Lingyu Academy",
                //     address: "6th Floor, No. 35, Lane 513, Ruiguang Road, Neihu District, Taipei City",
                //     tel: "886-2-2656-0777",
                //     fax: "",
                //     show: false
                // }
            ],
            slickOptions: {
                slidesToShow: 4,
                slidesToScroll: 4,
                rows: 3,
                infinite: true,
                initialSlide: DEFAULT_PAGE_COUNT - 1,
                arrows: true,
                centerPadding: '1rem',
                dots: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            rows: 3,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 426,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            rows: 3,
                            arrows: false
                        }
                    }
                ]
            },
        }
    },
    computed: {
        ...optionComputed,
        contactTelArr: function() {
            let result = []
            this.contactList.forEach((item) => {
                let res = {
                    tel: "",
                    fax: ""
                }
                let telArr = item.tel.split("-")
                let faxArr = item.fax.split("-")
                res.tel = "(" + telArr[0] + "-" + telArr[1] + ")" + telArr[2] + "-" + telArr[3]
                res.fax = "(" + faxArr[0] + "-" + faxArr[1] + ")" + faxArr[2] + "-" + faxArr[3]
                result.push(res)
            })
            return result
        }
    },
    created() {
        const brandRowSize = Math.floor(this.currentBrandList.length/3)
        this.brandList = Array.from({ length: 3 }, (_, index) =>
            this.currentBrandList.slice(index * brandRowSize, (index + 1) * brandRowSize)
        );
        this.brandList[0].reverse()
        this.brandList[2].reverse()
    },
    methods: {
        showContactDetail: function(index) {
            if(this.contactList[index]) {
                this.contactList[index].show = !this.contactList[index].show
            }
        },
        onNext() {
            this.$refs.slick.next()
        },
        onPrev() {
            this.$refs.slick.prev()
        },
        nlToBr(item) {
            return nlToBr(item)
        },
        onBeforeChange(event, slick, currentSlide, nextSlide) {
            this.pageCount = nextSlide + 1
        },
        toggleBrandText(index) {
            if(this.brandList[index]){
                this.brandList.forEach((item, _index) => {
                    if(_index === index) {
                        item.showTxt = !item.showTxt
                    } else {
                        item.showTxt = false
                    }
                })
            }
        }
    },
}
</script>
<template>
<Layout>
    <div :class="$style.home">
        <SectionBanner
            v-if="module.slideshow"
            :list="module.slideshow"
            :is-en="true"
        />
        <div class="section" style="background-color: #F8F8F8">
            <span id="about" class="anchor"></span>
            <div class="container isSmallWidth">
                <div style="padding-top: 17px;">
                    <h2 class="Home-title" 
                        ><span class="Home-title__main">About Zero One Technology</span>
                        <span class="Home-title__sub">Your Best Partner for Enterprise IT Modernization</span>
                    </h2>
                    <p v-if="aboutCompany.descriptionEn" class="description color-gray-6 text-center" v-html="nlToBr(aboutCompany.descriptionEn)"></p>
                    <div class="text-center mt-5">
                        <BaseButton
                            class="en isStylePrimary isRadius isCol4"
                            href="mailto:marketing@zerone.com.tw"
                            >
                            CONTACT US
                        </BaseButton>
                    </div>
                </div>
            </div>
        </div>
        <div :class="$style.SectionBrand" class="section">
            <span id="brand" class="anchor"></span>
            <div class="container isSmallWidth">
                <div>
                    <h2 class="Home-title">
                        <span class="Home-title__main">Products</span>
                        <span class="Home-title__sub">Leading IT Integration Solutions <br> for Diverse Enterprise Application</span>
                    </h2>
                    <div class="viewBox autoplay d-lg-block d-none">
                        <div v-for="(brands, index) in brandList" :key="index" class="d-flex view">
                            <div class="brand__list" 
                                :style=" index === 1 ? 'animation-duration:' + brands.length * 8 + 's;' + 'animation-delay:' + -brands.length * 8 + 's' : 'animation-duration:' + brands.length * 8 + 's;'" 
                            >
                            <!-- <div class="brand__list" > -->
                                <div
                                    v-for="(item, _index) in brands"
                                    :key="`item-${_index}`"
                                    class="brand__item"
                                    :class="{ 'showTxt': item.showTxt }"
                                    style="cursor: pointer;"
                                >
                                    <!-- <img src="@assets/images/newLOGO_NetApp.png" :alt="item.title"> -->

                                    <img v-if="item.logo_image" :src="item.logo_image" :alt="item.title">
                                    <div v-else class="noImg">{{ item.title }}</div>
                                    <span>{{ item.title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 d-block d-lg-none">
                        <Slick
                            ref="slick"
                            :options="slickOptions"
                            class="listCourse__carouselList brand__list slick isStyleBase"
                            @beforeChange="onBeforeChange"
                        >
                            <div
                                v-for="(item, index) in currentBrandList"
                                :key="`item-${index}`"
                                class="brand__item"
                                :class="{ 'showTxt': item.showTxt }"
                                style="cursor: pointer;" @click="toggleBrandText(index)"
                            >
                                <span>{{ item.title }}</span>
                                <img  v-if="item.logo_image" :src="item.logo_image" :alt="item.title">
                                <div v-else class="noImg">{{ item.title }}</div>
                            </div>
                        </Slick>
                    </div>
                </div>
            </div>
        </div>
        <div :class="$style.SectionContact" class="section">
            <span id="contact" class="anchor"></span>
            <div class="container isSmallWidth">
                <div>
                    <h2 class="Home-title" 
                        ><span class="Home-title__main">Contact Us</span>
                        <span class="Home-title__sub">Professional Service and Demand Creation <br> for Satisfied Customers</span>
                    </h2>
                </div>
                <div class="row mt-5">
                    <div v-for="(item, index) in contactList" :key="index" class="col-12 col-md-6" style="margin-bottom: 2rem;">
                        <div  class="card item-shadow p-5" style="cursor: pointer;" :class="{ 'show': item.show }" @click="showContactDetail(index)">
                            <div class="title">
                                {{ item.title }}
                                <span class="bottom-line"></span>
                            </div>
                            <ul v-show="item.show" class="info list-unstyled mt-5">
                                <li>
                                    Address:
                                    <a
                                        :href="'https://www.google.com.tw/maps/search/' + item.address"
                                        target="_blank"
                                        class="info__Item text-decoration-none"
                                    >
                                        {{ item.address }}
                                    </a>
                                </li>
                                <li>
                                    Tel:
                                    <a
                                        :href="'tel:' + item.tel"
                                        class="info__Item text-decoration-none"
                                    >
                                        {{ contactTelArr[index].tel }}
                                    </a>
                                </li>
                                <li v-if="item.fax">
                                    Fax:
                                    <a
                                        :href="'tel:' + item.fax"
                                        class="info__Item text-decoration-none"
                                    >
                                        {{ contactTelArr[index].fax }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Layout>

</template>
<style>
.section {
    position: relative;
}
.section .anchor {
    position: absolute;
    top: -113px;
}
.slick.isStyleBase.slick-dotted {
    margin-bottom: -12rem;
}
.slick.isStyleBase .slick-arrow{
    height: calc( 100% - 12rem);
    transform: translateY(0%);
    top: 0;
}

@keyframes autoPlay {
    from {
        transform: translateX(1%);
    }
    to {
        transform: translateX(calc(-101% + 355px*3));
    }
}
.autoplay .view:nth-child(odd) .brand__list {
    animation: autoPlay 25s infinite linear alternate-reverse;
}
.autoplay .view:nth-child(even) .brand__list {
    animation: autoPlay 25s -25s infinite linear alternate-reverse both;
}
.autoplay:hover .view .brand__list{
    animation-play-state: paused;
}
@media screen and (max-width: 576px) {
    .section {
        padding-top: 48px;
    }
}
</style>
<style lang="scss" module>

  .home{
    @include max-md {
      background: transparent linear-gradient(180deg, rgba(244, 246, 250, 1) 0%, rgba(255, 255, 255, 1) 100%) 0% 0% no-repeat padding-box;
    }
    .inside-link{
        text-decoration: underline;
    }
    :global {
        .section {
            padding-top: 100px;
            padding-bottom: 100px;
        }
        .Home-title {
            margin-bottom: 50px;
            .Home-title__main {
                letter-spacing: -0.04rem;
                font-weight: 600;
            }
        }
        p.description {
            letter-spacing: 0.16px;
            margin-bottom: 60px;
        }
        .container.isSmallWidth {
            @media screen and (max-width: 1608px) {
                max-width: 77%
            }
        }
    }
  }
  .SectionContact {
    padding-top: 40px !important;
    :global {
        padding-left: 25px;
        .card {
            letter-spacing: 0;
            &.show {
                height: 100%;
            }
            .title {
                font-size: 1.5rem;
                font-weight: 600;
                position: relative;
                &::before {
                    position: absolute;
                    bottom: -20px;
                    left: 0;
                    width: 5px;
                    height: 5px;
                    content: '';
                    background-color: $color-primary;
                    border-radius: 50%;
                    @include max-md {
                        bottom: -0.875rem;
                    }
                }

                &::after {
                    position: absolute;
                    bottom: -20px;
                    left: 10px;
                    width: 5px;
                    height: 5px;
                    content: '';
                    background-color: $color-primary;
                    border-radius: 50%;
                    @include max-md {
                        bottom: -0.875rem;
                    }
                }
                .bottom-line {
                    position: absolute;
                    bottom: -20px;
                    left: 20px;
                    width: 30px;
                    height: 5px;
                    background-color: $color-primary;
                    border-radius: 4px;
                    @include max-md {
                        bottom: -0.875rem;
                    }
                }
            }
            .info {
                font-size: 1rem;
                transition: 0.3s;
                line-height: 1.5;
                a.info__Item {
                    text-decoration: none;
                    color: #1d293f;
                    &:hover {
                        color: $color-primary
                    }
                }
            }
        }
    }
  }
  .SectionBrand {
    :global {
        padding-bottom: 40px !important;
        .viewBox{
            overflow: hidden;
            &.autoplay {
                position: relative;
            }
            &::before {
                position: absolute;
                content: "";
                display: block;
                left: 0;
                top: 0;
                height: 100%;
                width: 1rem;
                background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
                z-index: 2;
            }
            &::after {
                position: absolute;
                content: "";
                display: block;
                right: 0;
                top: 0;
                height: 100%;
                width: 1rem;
                background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
                z-index: 2;
            }
            .brand__list {
                justify-content: flex-start;
                flex-wrap: nowrap;
                .brand__item {
                    width: 355px;
                }
            }
        }
        .brand__list {
            margin-left: 0.06rem;
            display: flex !important;
            justify-content: space-around;
            .brand__item {
                display: inline-flex !important;
                align-items: center;
                justify-content: center;
                margin: 20px 0;
                text-align: center;
                height: 80px;
                @include max-sm {
                    margin: 0;
                }
                img {
                    display: block;
                    margin: auto;
                    max-width: 80%;
                    height: 100%;
                }
                span {
                    display: none;
                    height: 100%;
                    padding: 0 20px;
                    align-items: center;
                    letter-spacing: 0;
                }
                @include min-lg {
                    &:hover{
                        img {
                            display: none;
                        }
                        .noImg {
                            display: none;
                        }
                        span {
                            background-color: #E6E6E6;
                            display: flex;
                            justify-content: center;
                        }
                    }
                }
                &.showTxt {
                    img {
                        display: none;
                    }
                    .noImg {
                        display: none;
                    }
                    span {
                        background-color: #E6E6E6;
                        display: flex;
                        justify-content: center;
                    }
                }
            }
        }
    }
  }
</style>